import React, { useEffect, useMemo, useState } from "react";
import "./styles.scss";
import { Col, Container, Row } from "react-bootstrap";
import { IoNewspaperOutline } from "react-icons/io5";
import { Tabs } from "antd";

import Header from "../../component/header";
import SubHeader from "./subHeader";
import Footer from "../../component/footer/footer";
// import GoogleAds from "../../component/adds/googleAdds";

import { API } from "../../Config/API";
import { GET, POST } from "../../utils/apiCalls";
import moment from "moment";

import { useNavigate, useSearchParams } from "react-router-dom";
import { getURL } from "../../utils/getCdnURL";
import { onImgErrorFallback } from "../../utils/mediaFallback";
// import StickyAdds from "../../component/adds/stickyAdds";
import { FaArrowRightLong } from "react-icons/fa6";
import Edition from "../../Config/edition.json";
import { useSubscriptionCheck } from "../../hooks/useSubscriptionCheck";
import SubscriptionModal from "../../components/SubscriptionModal";
import RenewalModal from "../../components/RenewalModal";

function Homescreen() {
  const navigate = useNavigate();
  const { status: subStatus, daysLeft, endDate } = useSubscriptionCheck();

  const [showRenewal, setShowRenewal] = useState(false);
  const [subModal, setSubModal] = useState<{
    visible: boolean;
    type: "expired" | "expiring_soon" | "none";
    pendingItem: any;
  }>({ visible: false, type: "expired", pendingItem: null });

  const [searchParams] = useSearchParams();
  const [data, setData] = useState([]);
  const [njayar, setNjayar] = useState<any>([]);
  // const [vidyaPrabhaatham, setVidyaPrabhaatham] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);

  const format = "YYYY-MM-DD";
  const date = searchParams.get("date");
  const edition = searchParams.get("edition");

  const selectedEdition = useMemo(
    () => (edition ? Edition.find((e) => e.value === edition) : null),
    [edition]
  );
  const selectedEditionType = selectedEdition?.type ?? null;

  const defaultTab = selectedEditionType === "gulf" ? "gulf" : "main";
  const activeTab = selectedEditionType
    ? defaultTab
    : searchParams.get("tab") || "main";

  const onTabChange = (key: string) => {
    const params = new URLSearchParams(searchParams);
    params.set("tab", key);
    navigate(`/?${params.toString()}`);
  };

  const editionOrderMap = useMemo(() => {
    const map: Record<string, number> = {};
    Edition.forEach((e) => { map[e.value] = e.order; });
    return map;
  }, []);

  const gulfEditionValues = useMemo(
    () => Edition.filter((e) => e.type === "gulf").map((e) => e.value),
    []
  );

  const selectedEditionLabel = selectedEdition
    ? `${selectedEdition.name} Edition`
    : null;

  const mainData = useMemo(
    () => data
      .filter((item: any) => !gulfEditionValues.includes(item?.edition))
      .sort((a: any, b: any) => (editionOrderMap[a?.edition] ?? 99) - (editionOrderMap[b?.edition] ?? 99)),
    [data, gulfEditionValues, editionOrderMap]
  );

  const gulfData = useMemo(
    () => data
      .filter((item: any) => gulfEditionValues.includes(item?.edition))
      .sort((a: any, b: any) => (editionOrderMap[a?.edition] ?? 99) - (editionOrderMap[b?.edition] ?? 99)),
    [data, gulfEditionValues, editionOrderMap]
  );

  useEffect(() => {
    let obj = {
      type: "all",
      edition: edition,
      limit: 20,
      createdAt: moment(new Date()).format("YYYY-MM-DD"),
    };

    if (edition) {
    } else {
      loadData(obj);
    }
    loadNjayar({
      type: "all",
      edition: "njayar",
      limit: 4,
      createdAt: "",
    });
    // loadVidyaPrabhaatham();
  }, []);

  useEffect(() => {
    const dates = searchParams.get("date");
    const editions = searchParams.get("edition");
    if (dates || editions) {
      let obj = {
        type: "all",
        edition: editions,
        limit: 20,
        createdAt: dates,
      };
      loadData(obj);
    }
  }, [searchParams]);

  const loadData = async (obj: any) => {
    try {
      setIsLoading(true);
      let url = API.EPAPER;
      const response: any = await POST(url, obj);
      if (response?.length) {
        setData(response);
      } else {
        setData([]);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  const loadNjayar = async (obj: any) => {
    try {
      setIsLoading(true);
      let url = API.EPAPER;
      const response: any = await POST(url, obj);
      if (response?.length) {
        setNjayar(response);
      } else {
        setNjayar([]);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  const doNavigate = (item: any) => {
    navigate(
      `/details/${item?.edition}/${moment(item?.date).format(format)}/1/${item?.id}`,
    );
  };

  const handleClick = (item: any) => {
    // Subscription locking temporarily disabled
    // if (subStatus === "none") {
    //   setSubModal({ visible: true, type: "none", pendingItem: item });
    //   return;
    // }
    // if (subStatus === "expired") {
    //   setSubModal({ visible: true, type: "expired", pendingItem: item });
    //   return;
    // }
    // if (subStatus === "expiring_soon") {
    //   setSubModal({ visible: true, type: "expiring_soon", pendingItem: item });
    //   return;
    // }
    doNavigate(item);
  };

  // **MARKED UPDATE** - Prevent image dragging handler (TypeScript fixed)
  const preventImageDrag = (e: React.DragEvent<HTMLImageElement>) => {
    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  // **MARKED UPDATE** - Disable drag on all images in homescreen (TypeScript fixed)
  useEffect(() => {
    const images = document.querySelectorAll(".Homescreen-box img");
    images.forEach((img) => {
      const imageElement = img as HTMLImageElement;
      imageElement.draggable = false;
      imageElement.addEventListener("dragstart", (e) => {
        e.preventDefault();
        e.stopPropagation();
        return false;
      });
    });

    // Cleanup event listeners
    return () => {
      images.forEach((img) => {
        const imageElement = img as HTMLImageElement;
        imageElement.removeEventListener("dragstart", (e) => {
          e.preventDefault();
          e.stopPropagation();
          return false;
        });
      });
    };
  }, [data]); // Re-run when data changes

  return (
    <div>
      <Header
        onChange={(val: any) => {
          loadData(val);
          loadNjayar({
            type: "all",
            edition: "njayar",
            limit: 20,
            createdAt: "",
          });
        }}
      />
      <SubHeader
        edition={edition}
        date={date ? date : moment(new Date()).format("YYYY-MM-DD")}
      />
      <div className="Homescreen-box">
        <Container>
          {/* <GoogleAds /> */}
          <br />
          <Tabs
            activeKey={activeTab}
            onChange={onTabChange}
            className="Homescreen-editionTabs"
            items={[
              ...(selectedEditionType === "gulf"
                ? []
                : [
                    {
                      key: "main",
                      label:
                        selectedEditionType === "main" && selectedEditionLabel
                          ? selectedEditionLabel
                          : "Main Editions",
                      children: isLoading ? (
                        <div className="Homescreen-loading">Loading . . .</div>
                      ) : mainData?.length ? (
                        <Row>
                          {mainData?.map((item: any) => {
                            let imageURL = getURL(item?.image);
                            return (
                              <Col sm={3} key={item?.id} onClick={() => handleClick(item)}>
                                <div className="Homescreen-item">
                                  <div className="Homescreen-itemBox">
                                    <img
                                      src={imageURL}
                                      className="Homescreen-itemImg"
                                      alt="suprabhaatham-epaper"
                                      draggable={false}
                                      onDragStart={preventImageDrag}
                                      onContextMenu={(e) => e.preventDefault()}
                                      onError={onImgErrorFallback}
                                    />
                                  </div>
                                  <div className="Homescreen-itemBox2">
                                    <div>
                                      {item?.edition} -{" "}
                                      {moment(item?.date).format("DD-MM-yyyy")}
                                    </div>
                                  </div>
                                </div>
                              </Col>
                            );
                          })}
                        </Row>
                      ) : !edition ? (
                        <div className="Homescreen-empty">
                          <IoNewspaperOutline size={50} color="grey" />
                          <div style={{ margin: 10 }} />
                          <div>No editions available</div>
                        </div>
                      ) : (
                        <div className="Homescreen-empty">
                          <IoNewspaperOutline size={50} color="grey" />
                          <div style={{ margin: 10 }} />
                          <div>Sorry Epaper not found</div>
                        </div>
                      ),
                    },
                  ]),
              ...(selectedEditionType === "main"
                ? []
                : [
                    {
                      key: "gulf",
                      label:
                        selectedEditionType === "gulf" && selectedEditionLabel
                          ? selectedEditionLabel
                          : "Gulf Editions",
                      children: isLoading ? (
                        <div className="Homescreen-loading">Loading . . .</div>
                      ) : gulfData?.length ? (
                        <Row>
                          {gulfData?.map((item: any) => {
                            let imageURL = getURL(item?.image);
                            return (
                              <Col sm={3} key={item?.id} onClick={() => handleClick(item)}>
                                <div className="Homescreen-item">
                                  <div className="Homescreen-itemBox">
                                    <img
                                      src={imageURL}
                                      className="Homescreen-itemImg"
                                      alt="suprabhaatham-epaper"
                                      draggable={false}
                                      onDragStart={preventImageDrag}
                                      onContextMenu={(e) => e.preventDefault()}
                                      onError={onImgErrorFallback}
                                    />
                                  </div>
                                  <div className="Homescreen-itemBox2">
                                    <div>
                                      {item?.edition} -{" "}
                                      {moment(item?.date).format("DD-MM-yyyy")}
                                    </div>
                                  </div>
                                </div>
                              </Col>
                            );
                          })}
                        </Row>
                      ) : (
                        <div className="Homescreen-empty">
                          <IoNewspaperOutline size={50} color="grey" />
                          <div style={{ margin: 10 }} />
                          <div>Sorry Epaper not found</div>
                        </div>
                      ),
                    },
                  ]),
            ]}
          />
          <br />
          <div className="Head-section-m">
            <div className="Head-n">{"Njayar Prabhaatham"}</div>
            <span
              className="Homescreen-viewAll"
              onClick={() => navigate("/all-njayar-prabhaatham")}
            >
              View All &nbsp;
              <FaArrowRightLong />
            </span>
          </div>

          {isLoading ? (
            <div className="Homescreen-loading">Loading . . .</div>
          ) : njayar?.length ? (
            <Row>
              {njayar?.map((item: any) => {
                let imageURL = getURL(item?.image);
                return (
                  <Col sm={3} key={item?.id} onClick={() => handleClick(item)}>
                    <div className="Homescreen-item">
                      <div className="Homescreen-itemBox">
                        <img
                          src={imageURL}
                          className="Homescreen-itemImg"
                          alt="suprabhaatham-epaper"
                          draggable={false}
                          onDragStart={preventImageDrag}
                          onContextMenu={(e) => e.preventDefault()}
                          onError={onImgErrorFallback}
                        />
                      </div>

                      <div className="Homescreen-itemBox2">
                        <div>
                          {item?.edition}&nbsp;-&nbsp;
                          {moment(item?.date).format("DD-MM-yyyy")}
                        </div>
                      </div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          ) : (
            <div className="Homescreen-loading">
              <IoNewspaperOutline size={50} color="grey" />
              <div style={{ margin: 10 }} />
              <div>Sorry Epaper not found</div>
            </div>
          )}

          {/* <br />
          <div className="Head-section-m">
            <div className="Head-n">{"Vidya Prabhaatham"}</div>
            <span
              className="Homescreen-viewAll"
              onClick={() => navigate("/all-vidya-prabhaatham")}
            >
              View All &nbsp;
              <FaArrowRightLong />
            </span>
          </div> */}

          {/* {isLoading ? (
            <div className="Homescreen-loading">Loading . . .</div>
          ) : vidyaPrabhaatham?.length ? (
            <Row>
              {vidyaPrabhaatham?.map((item: any) => {
                return (
                  <Col
                    sm={3}
                    key={item?.id}
                    onClick={() => handleClickVidya(item)}
                  >
                    <div className="Homescreen-item">
                      <div className="Homescreen-itemBox">
                        <img
                          src={item?.attributes?.image1}
                          className="Homescreen-itemImg1"
                          alt="suprabhaatham-epaper"
                          draggable={false}
                          onDragStart={preventImageDrag}
                          onContextMenu={(e) => e.preventDefault()}
                        />
                      </div>

                      <div className="Homescreen-itemBox2">
                        <div>{"Vidya Prabhaatham"}</div>
                        <div>
                          {moment(item?.attributes?.createdAt)
                            .utcOffset(330)
                            .format("DD-MMM-YYYY")}
                        </div>
                      </div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          ) : (
            <div className="Homescreen-loading">
              <IoNewspaperOutline size={50} color="grey" />
              <div style={{ margin: 10 }} />
              <div>Sorry Epaper not found</div>
            </div>
          )} */}
          <br />
          {/* <GoogleAds /> */}
        </Container>
        {/* <StickyAdds /> */}
      </div>
      <Footer />

      {subModal.visible && (
        <SubscriptionModal
          type={subModal.type}
          visible={subModal.visible}
          daysLeft={daysLeft}
          endDate={endDate}
          onClose={() => setSubModal((s) => ({ ...s, visible: false }))}
          onContinue={() => {
            if (subModal.pendingItem) doNavigate(subModal.pendingItem);
          }}
          onRenew={() => setShowRenewal(true)}
        />
      )}

      <RenewalModal
        visible={showRenewal}
        onClose={() => setShowRenewal(false)}
      />
    </div>
  );
}

export default Homescreen;
